import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PO from './PO';
import OSP from './OSP';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography component="span">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  console.log(index);
  return {
    id: `simple-tab-${index}`,
    className: 'text-white',
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
}));

export default function SimpleTabs(props) {
  // console.log(props);
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          // textColor="inherit"
        >
          <Tab
            label={
              <div
                className={
                  value === 0
                    ? 'font-bold text-xl text-red-500'
                    : 'font-bold text-xl text-white'
                }
              >
                PO
              </div>
            }
            {...a11yProps(0)}
          />
          <Tab
            label={
              <div
                className={
                  value === 1
                    ? 'font-bold text-xl text-red-500'
                    : 'font-bold text-xl text-white'
                }
              >
                JOB OSP
              </div>
            }
            {...a11yProps(1)}
          />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <PO history={props.history} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <OSP history={props.history} />
      </TabPanel>
    </div>
  );
}
